module.exports = __webpack_public_path__ + "static/media/ksvlogo.b64c9e37.png";